import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import { type SyntheticEvent, useState } from "react";

export const useUploadFiles = () => {
	const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
	const [warningMessage, setWarningMessage] = useState<boolean>(false);
	const [isDragging, setIsDragging] = useState(false);
	const {
		actions: { setUploadFileDialog },
	} = useAssetDetailsContext();

	const handleClose = (event?: SyntheticEvent, reason?: string) => {
		if (reason === "clickaway") {
			return;
		}
		setWarningMessage(false);
	};

	const handleCancel = async () => {
		setUploadFileDialog(false);
	};

	const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
		const files = event.target.files ? Array.from(event.target.files) : [];

		if (files.length) {
			const newFiles = [...selectedFiles];
			Array.from(files).forEach((file: any) => {
				const isFileAlreadySelected = selectedFiles.some(
					(selectedFile: any) =>
						selectedFile.name === file.name && selectedFile.size === file.size,
				);

				if (!isFileAlreadySelected) {
					newFiles.push(file);
				}
			});
			setSelectedFiles(newFiles);
		}
	};

	const handleDragOver = (event: any) => {
		setIsDragging(true);
		event.preventDefault();
	};

	const handleDrop = (event: any) => {
		setIsDragging(false);
		setWarningMessage(false);

		event.preventDefault();
		const files = event.dataTransfer.files;
		if (files.length >= 1) {
			const newFiles = [...selectedFiles];
			Array.from(files).forEach((file: any) => {
				// Paso 2: check if file exist
				if (
					!selectedFiles.some(
						(selectedFile: any) => selectedFile.name === file.name,
					)
				) {
					newFiles.push(file);
				}
			});
			setSelectedFiles(newFiles);
		}
	};

	return {
		handleFileSelect,
		handleDragOver,
		handleDrop,
		handleClose,
		handleCancel,
		setIsDragging,
		setSelectedFiles,
		selectedFiles,
		warningMessage,
		isDragging,
	};
};
